<template>
    <div class="content">
        <TopBar barTheme="white" :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`">
            <span class="page-title" slot="title">填写账号信息</span>
        </TopBar>
        <div class="receiving-info" v-bind:class="{'show-bg': virtualProductType === '50'}">
            <div class="pro-box wrap">
                <div class="pic-wrap vc">
                    <img :src="proImg" :alt="product.Name">
                </div>
                <div class="text-wrap">
                    <h3>{{product.Name}}</h3>
                    <p>所需积分：<span class="cur">{{product.Price}}积分</span></p>
                    <p>数量：<span class="black">1</span></p>
                </div>
            </div>
            <div class="info-box wrap" v-if="virtualProductType !== '50' && virtualProductType !== '30'">
                <div class="item-title vc"><i class="icon icon-line"></i>填写账号信息</div>
                <div class="item-detail">
                    <ul>
                        <li class="vc" v-if="virtualProductType !== '70'"><span>手机号：</span><input type="text" v-model="accountNum" placeholder="请填写会员本人的手机号"></li>
                        <li class="vc" v-else><span>充值油卡账号：</span><input type="text" v-model="accountNum" placeholder="请填写需要充值的油卡账号"></li>
                    </ul>
                </div>
            </div>
            <div class="bot-btn hvc">
                <a class="btn-item btn-submit hvc" @click="submit" href="javascript: void(0)">确认提交</a>
            </div>
            <div class="message-layer" v-if="msgShow">
                <div class="message-content">
                    <div class="msg-text">
                        <h3>{{msgTitle}}</h3>
                        <div class="msg-tip hvc" v-html="msgTip"></div>
                    </div>
                    <div class="msg-icon hc">
                        <i class="icon icon-error" v-if="msgType === 'error'"></i>
                        <i class="icon icon-success" v-if="msgType === 'success'"></i>
                        <i class="icon icon-checking" v-if="msgType === 'checking'"></i>
                    </div>
                    <div class="bottom-btn" v-if="msgType === 'error'">
                        <a class="btn-item btn-close hvc" href="javascript: void(0)" @click="closeMsg">关闭</a>
                    </div>
                    <div class="bottom-btn" v-if="msgType === 'success' || msgType === 'checking'">
                        <a class="btn-item btn-continue hvc" href="javascript: void(0)" @click="continueExchange">继续兑换</a>
                        <a class="btn-item btn-see hvc" href="javascript: void(0)" @click="see">查看我的礼品</a>
                    </div>
                </div>
            </div>
        </div>
        <Loading :loading="loading"></Loading>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import TopBar from '@/components/top-bar/'
    import { checkTel ,fuelCardVerify} from '@/libs/tools'
    import Loading from '@/components/loading'
    export default {
        name: 'accountNum',
        components: {
            TopBar,
            Loading
        },
        data: () => {
            return {
                productId: null,
                virtualProductType: undefined,
                product: {},
                proImg: '',
                accountNum: '',
                lockSubmit: false,
                msgShow: false,
                msgType: '', // success-成功  checking-待审核  error-出错了
                msgTitle: '',
                msgTip: '',
                loading: false
            }
        },
        mounted () {
            this.productId = this.$route.query.Id
            this.virtualProductType = this.$route.query.VirtualProductType
            this.getUserLevelPrivilege(this.productId)
                .then(res => {
                    this.product = res
                    this.proImg = res.Pictures[0]
                })
        },
        methods: {
            closeMsg () {
                this.msgShow = false
                this.lockSubmit = false
            },
            continueExchange () {
                this.$router.push('/member/shop/index')
            },
            see () {
                this.$router.push('/member/shop/gift')
            },
            submit () {
                if (this.lockSubmit) return false
                this.lockSubmit = true
                if (this.accountNum === '' && this.virtualProductType !== '50' && this.virtualProductType !== '30') {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = `未填写需要充值的${this.virtualProductType ==='70' ? '油卡账号' :'手机号'}`
                    this.msgShow = true
                    return false
                }
                if (!checkTel(this.accountNum) && (this.product.VirtualProductType === 10 ||
                    this.product.VirtualProductType === 20 || this.product.VirtualProductType === 40)) {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '填写手机号不正确'
                    this.msgShow = true
                    return false
                }

                if(!fuelCardVerify(this.accountNum) && this.product.VirtualProductType === 70){
                  this.msgType = 'error'
                  this.msgTitle = '出错啦'
                  this.msgTip = '填写油卡账号不正确'
                  this.msgShow = true
                  return false
              }
                //显示loading
                this.loading = true
                this.placeOrder({
                    productId: this.productId,
                    accountnum: this.accountNum
                })
                    .then(res => {
                        window.console.log(res)
                        if (res.errCode === 0) {
                            this.msgType = 'success'
                            this.msgTitle = '兑换成功'
                            this.msgTip = '请在48小时内查收短信通知'
                            this.msgShow = true
                        } else {
                            this.msgType = 'checking'
                            this.msgTitle = '待审核'
                            this.msgTip = '审核结果请于7天后查看'
                            this.msgShow = true
                        }
                    })
            },
            getUserLevelPrivilege (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetDetailById',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            Id,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            placeOrder (data) {
                try {
                    window.gio('track', 'RedeemSubmit', {'GiftID':this.productId});
                } catch (error) {
                    //console.log(error);
                }
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMOrder/PlaceOrder',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: data
                    })
                        .then(res => {
                            this.lockSubmit = false
                            this.loading = false
                            let _data = res.data
                            if (_data.errCode === 0 || _data.errCode === 10) {
                                resolve(_data)
                            } else if (_data.errCode === 1000 || _data.errCode === 1100) {
                                window.console.log(_data.errMsg)
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = '系统开小差了，<br>晚点再回来看看吧！'
                                this.msgShow = true
                            } else {
                                window.console.log(_data.errMsg)
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = _data.errMsg
                                this.msgShow = true
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .receiving-info{
        padding-top: 1.00rem;
        background-color: #f5f6f8;
        &.show-bg{
            height: 100vh;
        }
        .pro-box{
            display: flex;
            display: -webkit-flex;
            padding-top: 0.30rem;
            padding-bottom: 0.30rem;
            margin-bottom: 0.20rem;
            background-color: #fff;
            .pic-wrap{
                width: 2.25rem;
                height: 1.44rem;
                overflow: hidden;
                img{
                    width: 100%;
                    min-width: 1.40rem;
                }
            }
            .text-wrap{
                padding-left: 0.22rem;
                h3{
                    margin-bottom: 0.10rem;
                    font-weight: bold;
                    line-height: 0.32rem;
                }
                p{
                    color: #747d80;
                    line-height: 0.46rem;
                    .cur{
                        color: #ffa70d;
                    }
                    .black{
                        color: #282b2c;
                    }
                }
            }
        }
        .info-box{
            padding-top: 0.42rem;
            background-color: #fff;
            .item-title{
                height: 0.50rem;
                padding-bottom: 0.10rem;
                font-size: 0.30rem;
                .icon-line{
                    position: relative;
                    top: 0.01rem;
                    width: 0.04rem;
                    height: 0.30rem;
                    margin-right: 0.10rem;
                    background-color: #fbc500;
                    border-radius: 0.02rem;
                }
            }
            .item-detail{
                ul{
                    li{
                        height: 1.04rem;
                        border-bottom: #d4dbde solid 0.02rem;
                        span{
                            display: block;
                            white-space: nowrap;
                            //width: 1.38rem;
                        }
                        input{
                            width: 5.48rem;
                            height: 0.64rem;
                            &::placeholder{
                                color: #919b9f;
                            }
                            &:disabled{
                                background-color: transparent;
                            }
                        }
                    }
                }
            }
        }
        .bot-btn{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.25rem;
            border-top: #d4dbde solid 0.02rem;
            background-color: #fff;
            .btn-submit{
                display: flex;
                display: -webkit-flex;
                width: 6.92rem;
                height: 0.95rem;
                border-radius: 0.07rem;
                background-color: #fbc500;
                font-size: 0.30rem;
            }
        }
    }
</style>
